import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AdminLayout } from './layouts/AdminLayout'
import { Login } from './pages/Login'
import { lazy, Suspense } from 'react'

const queryClient = new QueryClient()

const Dashboard = lazy(() => import('./pages/Dashboard'))
const Orders = lazy(() => import('./pages/Orders'))
const Users = lazy(() => import('./pages/Users'))
const Settings = lazy(() => import('./pages/Settings'))
const OnlineStatsPage = lazy(() => import('./pages/OnlineStats'))
const Tracks = lazy(() => import('./pages/Tracks'))
const WorkoutStats = lazy(() => import('./pages/WorkoutStats'))

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/" element={<AdminLayout />}>
            <Route 
              path="dashboard" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <Dashboard />
                </Suspense>
              } 
            />
            <Route 
              path="orders" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <Orders />
                </Suspense>
              } 
            />
            <Route 
              path="users" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <Users />
                </Suspense>
              } 
            />
            <Route 
              path="settings" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <Settings />
                </Suspense>
              } 
            />
            <Route 
              path="online-stats" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <OnlineStatsPage />
                </Suspense>
              } 
            />
            <Route 
              path="tracks" 
              element={
                <Suspense fallback={<div className="loading-spinner" />}>
                  <Tracks />
                </Suspense>
              } 
            />
            <Route
              path="workout-stats"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <WorkoutStats />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
